import { render, staticRenderFns } from "./bulkShipment.vue?vue&type=template&id=0ffd9a30&scoped=true&"
import script from "./bulkShipment.vue?vue&type=script&lang=js&"
export * from "./bulkShipment.vue?vue&type=script&lang=js&"
import style0 from "./bulkShipment.vue?vue&type=style&index=0&id=0ffd9a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd9a30",
  null
  
)

export default component.exports